// src/utils/appHandoff.js (3.82.0, owner, Nov 4)
// Between the CP Fax app and this page, both ways. Backend: lib/appHandoff.js.
//
// The CP Fax app opens the portal with ?handoff=<code>, a one-time code that
// signs this browser in (useAuth; backend lib/appHandoff.js). It leaves the
// address the moment this file loads, before anything is drawn, so it never
// stays in the history; any other parameters (?fax=…) are kept.
let code = null;
try {
  const u = new URL(window.location.href);
  if (u.searchParams.has('handoff')) {
    code = u.searchParams.get('handoff');
    u.searchParams.delete('handoff');
    window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
  }
} catch { /* no code: the usual sign-in */ }

// 3.82.0: the app signing in through this page, so it has Google, Microsoft
// and passkeys: ?app-signin=<state>&port=<port>&challenge=<challenge>. Once
// the person is signed in, the browser goes to the app's listener on this
// device (pages/AppSignIn.jsx). Kept for this tab only, so it survives a
// reload on the sign-in page. Anything but a plain port number is ignored: the
// only address it ever goes to is http://127.0.0.1:<port>.
const SIGN_IN_KEY = 'faxPortal.appSignIn';
const SIGN_IN_LIFE_MS = 10 * 60 * 1000;
function appSignInFrom(q) {
  const state = q.get('app-signin') || '', port = q.get('port') || '', challenge = q.get('challenge') || '';
  if (!/^[A-Za-z0-9_-]{16,128}$/.test(state) || !/^[A-Za-z0-9_-]{43}$/.test(challenge)) return null;
  if (!/^[1-9][0-9]{3,4}$/.test(port) || Number(port) < 1024 || Number(port) > 65535) return null;
  return { state, port: Number(port), challenge };
}
try {
  const u = new URL(window.location.href);
  if (u.searchParams.has('app-signin')) {
    const request = appSignInFrom(u.searchParams);
    // never inside another site's frame, where a click could be tricked out of someone
    if (request && window.top === window.self) sessionStorage.setItem(SIGN_IN_KEY, JSON.stringify({ ...request, at: Date.now() }));
    ['app-signin', 'port', 'challenge'].forEach(k => u.searchParams.delete(k));
    window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
  }
} catch { /* no request: the usual portal */ }

// The app's request in this tab, or null when there's none or it's too old
export function pendingAppSignIn() {
  try {
    const r = JSON.parse(sessionStorage.getItem(SIGN_IN_KEY) || 'null');
    return r && Date.now() - r.at < SIGN_IN_LIFE_MS ? r : null;
  } catch { return null; }
}
export function endAppSignIn() {
  try { sessionStorage.removeItem(SIGN_IN_KEY); } catch { /* nothing kept */ }
}
export const appCallbackUrl = (request, code) =>
  `http://127.0.0.1:${request.port}/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(request.state)}`;

// The code, once
export function takeHandoffCode() {
  const c = code;
  code = null;
  return c;
}
